<div class="bg"></div>
<div class="lds-ring text-gray">
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>
